import dataProvider from "../../../../../providers/data-provider";
import { ProfileEnum } from "../../../../../utils/general-profile.enum";
import DashboardFilter from "./dashboard-filter";

const fetchAcademicPeriods = async (shouldFetch, search, institutionBranchId) => {

    if (shouldFetch) {
        const response = await dataProvider.getList(
            'academic-periods',
            {
                pagination: { page: 1, perPage: 20 },
                sort: { field: 'name', order: 'ASC' },
                filter: { [`academic-period.name`]: search, [`institution_branch.id`]: institutionBranchId }
            })
        return response.data;
    }
    else { return [] }
}

export const AcademicPeriodFilter = ({ profile, filters, setFilters }) => {

    const shouldFetch = profile === ProfileEnum.ADMIN ? true : filters?.institutionBranchId

    return <DashboardFilter
        filterKey="academicPeriodId"
        label="Período letivo"
        value={filters?.academicPeriod?.id}
        setFilters={setFilters}
        fetchOptions={(search) => fetchAcademicPeriods(shouldFetch, search, filters?.institutionBranchId)}
        disabled={!shouldFetch}
    />
}